import { getLocalStorageObject, setLocalStorageObject } from '@xylabs/react-shared'

import { FunnelData } from './FunnelData'

const KEY = '_coin_funnel_data'

export class Funnel {
  public data: FunnelData
  private constructor() {
    this.data = {}
    this.load()
  }

  public load() {
    this.data = getLocalStorageObject<FunnelData>(KEY) ?? {}
  }

  public setFunnelName(name: string) {
    this.data.funnel = name
    setLocalStorageObject(KEY, this.data)
  }

  static instance: Funnel
  static get() {
    this.instance = this.instance ?? new Funnel()
    return this.instance
  }
}
